var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator");

(function () {
  "use strict";

  var e = {
    306: function _(e, t, a) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = a(861),
          i = a(376);

      t.default = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
          var a, n, _yield$i$default, s, u, o, d, l, _loop, _e;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (/(^http(s?):\/\/[^\s$.?#].[^\s]*)/i.test(e)) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", null);

                case 2:
                  _context.next = 4;
                  return i.default(e, t);

                case 4:
                  _yield$i$default = _context.sent;
                  s = _yield$i$default.data;
                  u = r.parse(s, {
                    attributeNamePrefix: "",
                    textNodeName: "$text",
                    ignoreAttributes: !1
                  });
                  o = u.rss && u.rss.channel ? u.rss.channel : u.feed;
                  Array.isArray(o) && (o = o[0]);
                  d = {
                    title: null !== (a = o.title) && void 0 !== a ? a : "",
                    description: null !== (n = o.description) && void 0 !== n ? n : "",
                    link: o.link && o.link.href ? o.link.href : o.link,
                    image: o.image ? o.image.url : o["itunes:image"] ? o["itunes:image"].href : "",
                    category: o.category || [],
                    items: []
                  };
                  l = o.item || o.entry;
                  l && !Array.isArray(l) && (l = [l]);

                  _loop = function _loop(_e) {
                    var t = l[_e];
                    var a = {},
                        r = {
                      id: t.guid && t.guid.$t ? t.guid.$t : t.id,
                      title: t.title && t.title.$text ? t.title.$text : t.title,
                      description: t.summary && t.summary.$text ? t.summary.$text : t.description,
                      link: t.link && t.link.href ? t.link.href : t.link,
                      author: t.author && t.author.name ? t.author.name : t["dc:creator"],
                      published: t.created ? Date.parse(t.created) : t.pubDate ? Date.parse(t.pubDate) : Date.now(),
                      created: t.updated ? Date.parse(t.updated) : t.pubDate ? Date.parse(t.pubDate) : t.created ? Date.parse(t.created) : Date.now(),
                      category: t.category || [],
                      content: t.content && t.content.$text ? t.content.$text : t["content:encoded"],
                      enclosures: t.enclosure ? Array.isArray(t.enclosure) ? t.enclosure : [t.enclosure] : []
                    };
                    ["content:encoded", "podcast:transcript", "itunes:summary", "itunes:author", "itunes:explicit", "itunes:duration", "itunes:season", "itunes:episode", "itunes:episodeType", "itunes:image"].forEach(function (e) {
                      t[e] && (r[e.replace(":", "_")] = t[e]);
                    }), t["media:thumbnail"] && (Object.assign(a, {
                      thumbnail: t["media:thumbnail"]
                    }), r.enclosures.push(t["media:thumbnail"])), t["media:content"] && (Object.assign(a, {
                      thumbnail: t["media:content"]
                    }), r.enclosures.push(t["media:content"])), t["media:group"] && (t["media:group"]["media:title"] && (r.title = t["media:group"]["media:title"]), t["media:group"]["media:description"] && (r.description = t["media:group"]["media:description"]), t["media:group"]["media:thumbnail"] && r.enclosures.push(t["media:group"]["media:thumbnail"].url)), Object.assign(r, {
                      media: a
                    }), d.items.push(r);
                  };

                  for (_e = 0; _e < l.length; _e++) {
                    _loop(_e);
                  }

                  return _context.abrupt("return", d);

                case 15:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
    },
    376: function _(e) {
      e.exports = require("axios");
    },
    861: function _(e) {
      e.exports = require("fast-xml-parser");
    }
  },
      t = {};

  function a(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var n = t[r] = {
      exports: {}
    };
    return e[r](n, n.exports, a), n.exports;
  }

  var r = {};

  (function () {
    var e = r;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.Parse = e.parse = void 0;
    var t = a(306);
    e.parse = t.default;
    var i = t.default;
    e.Parse = i, e.default = t.default;
  })();

  var i = exports;

  for (var n in r) {
    i[n] = r[n];
  }

  r.__esModule && Object.defineProperty(i, "__esModule", {
    value: !0
  });
})();